import React, { useCallback } from 'react'
import s from './photos-grid.module.scss'
import { useDropzone } from 'react-dropzone';
import { IconCamera, IconX } from '@tabler/icons-react';
import { Button } from '@shared/ui/button/button';
import { Loader } from '@shared/ui/loader/loader';
import { useAttachFileModal } from '@features/attach-files';

const MAX_PHOTOS = 6;
const MAX_PHOTO_SIZE = 3145728; // 3 мб

export const PhotosGrid = ({myFiles, setMyFiles, setGlobalFiles, globalFiles, photosIsPending}) => {
	const { open: openAttachFileModal } = useAttachFileModal();

	const totalFiles = [...myFiles, ...globalFiles].length;

	const onDrop = useCallback(
		(acceptedFiles) => {
			setMyFiles([...myFiles, ...acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      }))]);
		},
	[myFiles, setMyFiles]);

	const handleSelect = useCallback(
		(items) => {
			const newFiles = items
				.filter((item) => item instanceof File)
				.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) }));
			const existing = items.filter((item) => !(item instanceof File));

			if (newFiles.length) {
				setMyFiles((prev) => [...prev, ...newFiles].slice(0, MAX_PHOTOS));
			}
			if (existing.length) {
				setGlobalFiles((prev) => [...prev, ...existing].slice(0, MAX_PHOTOS));
			}
		},
		[setMyFiles, setGlobalFiles]
	);

	const openFileManager = () => {
		openAttachFileModal({
			multiple: true,
			maxFiles: Math.max(MAX_PHOTOS - totalFiles, 1),
			onlyCategory: 'image',
			maxSize: MAX_PHOTO_SIZE,
			onSelect: handleSelect,
		});
	};

	const { getRootProps, getInputProps } = useDropzone({
		accept: {
			'image/jpeg': [],
			'image/png': [],
			'image/webp': [],
		},
		maxFiles: MAX_PHOTOS - totalFiles,
		onDrop,
		maxSize: MAX_PHOTO_SIZE,
		disabled: totalFiles >= MAX_PHOTOS,
		noClick: true,
		noKeyboard: true,
	});

	const removeFiles = (name) => {
		setMyFiles((prev) => prev.filter((el) => el.name !== name));
	};

	const removeGlobalFiles = (name) => {
		setGlobalFiles((prev) => prev.filter((el) => el.name !== name));
	};

	if(photosIsPending){
		return <Loader/>
	}

	return (
		<div className={s.wrapper} {...getRootProps()}>
			{(myFiles?.length > 0 || globalFiles?.length > 0) &&
				[...myFiles, ...globalFiles].map((el) => (
					<div className={s.fileWrapper} key={el?.name + '-image'}>
						<img src={el?.file ? process.env.REACT_APP_STORAGE_URL + el.file : el?.preview} alt="" className={s.image}/>
						<button
							className={s.removeBtn}
							onClick={() => el?.file ? removeGlobalFiles(el.name) : removeFiles(el.name)}
						>
							<IconX size={16} className={s.icon}/>
						</button>
				</div>
			))}
			<input {...getInputProps()} />
			{totalFiles < MAX_PHOTOS && <Button
				label={<>
					<IconCamera size={24} />
					Добавить
				</>}
				size="small"
				className={s.plusBtn}
				disabled={totalFiles >= MAX_PHOTOS}
				onClick={openFileManager}
			/>}
		</div>
	)
}
